import React, { useContext, useEffect, useMemo } from 'react';
import { CaptionText, DropdownMenu } from '@paypalcorp/pp-react';

import styles from './ContactModule.module.less';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import { IntegrationPageSectionT } from '../StateManagement/types';
import { contactPreferenceEnum } from '../../../constants/constants';

type Map = {
  [key: string]: string;
};

const contactPreferenceOptions = Object.keys(contactPreferenceEnum).map((key) => ({
  label: (contactPreferenceEnum as Map)[key],
  value: (contactPreferenceEnum as Map)[key]
}));

type IProps = {
  codeBlockKey: string;
};

const ContactModule = ({ codeBlockKey: keyList }: IProps) => {
  const codeBlockKey = useMemo(() => keyList.split(',')[1], [keyList]);

  const {
    code,
    OrderConfigurator: { contactPreference, updateContactModulePreference }
  } = useContext(IntegrationPageSectionContext) as IntegrationPageSectionT;

  const isSectionActive = code.status[codeBlockKey];

  useEffect(() => {
    if (isSectionActive) {
      updateContactModulePreference(contactPreferenceEnum.noContactInfo);
    } else if (contactPreference) {
      updateContactModulePreference('');
    }
  }, [isSectionActive]);

  const handleOptionSelect = (e: React.ChangeEvent<HTMLButtonElement>) => {
    updateContactModulePreference(e.target.value);
  };

  if (!isSectionActive) return <></>;

  return (
    <div className={styles.wrapper}>
      <CaptionText className={styles.label}>Contact Preference</CaptionText>
      <DropdownMenu
        label="Contact Preference"
        value={contactPreference}
        options={contactPreferenceOptions}
        onChange={handleOptionSelect}
        className={styles.dropdown}
        data-testid="contact-preference-dropdown"
      />
    </div>
  );
};

export default ContactModule;
